export default function IndividualPresent({ individual }) {
  return <div>{individual} needs to be present</div>;
}
